$(function () {
  if (!customElements.get('subscribe-form')) {
    customElements.define(
      'subscribe-form',
      class subscribeForm extends HTMLElement {
        constructor() {
          super();
        }
        emailRegexp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        connectedCallback() {
          this.init();
        }

        init() {
          const root = $(this);
          const $inputDom = root.find('.input_text');
          const $formDom = root.find('form');
          const $emailDom = root.find('.subscribe_button');
          const $inputContainer = $inputDom.parents('.input_text_container');
          this.emptyEmail();
          $inputDom.on('input', () => {
            this.emptyEmail();
          });
          $emailDom.on('click', (event) => {
            event.preventDefault();
            const emailValue = $inputDom.val();
            if (emailValue) {
              if (this.emailRegexp.test(emailValue)) {
                $formDom.submit();
              }
            } else {
              $inputContainer.attr('data-error', 'true');
            }
          });
        }
        emptyEmail() {
          const root = $(this);
          const $inputDom = root.find('.input_text');
          const $emailDom = root.find('.subscribe_button');
          if ($inputDom.val().length > 0) {
            $emailDom.attr('data-empty', 'false');
          } else {
            $emailDom.attr('data-empty', 'true');
          }
        }
      }
    );
  }
});
